import React from 'react'

import { withRouter } from 'react-router-dom'

import { AutoComplete } from 'primereact/autocomplete';
import { MultiSelect } from 'primereact/multiselect'
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { Calendar } from 'primereact/calendar'
import { InputNumber } from 'primereact/inputnumber'
import { Checkbox } from 'primereact/checkbox'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import fileDownload from 'js-file-download'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import UsuarioService from '../../app/service/UsuarioService'
import PessoaService from '../../app/service/PessoaService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import StatusProcessualService from '../../app/service/StatusProcessualService'
import TipoAcaoService from '../../app/service/TipoAcaoService'
import AreaAtuacaoService from '../../app/service/AreaAtuacaoService'
import RelatorioProcessoService from '../../app/service/RelatorioProcessoService'
import ObjetoAcaoService from '../../app/service/ObjetoAcaoService'
import RitoService from '../../app/service/RitoService'

class RelatorioProcessoFama extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pessoas: [],
      pessoa: null,
      filterPessoas: null,
      dataCadastroInicial: '',
      dataCadastroFinal: '',
      responsaveis: [],
      responsavel: null,
      bancadas: [],
      bancada: null,
      estado: null,
      numeroProcesso: '',
      favorito: null,
      estrategico: null,
      importante: null,
      gruposTrabalho: [],
      grupoTrabalho: null,
      statusProcessuais: [],
      statusProcessual: null,
      areasAtuacao: [],
      areaAtuacao: null,
      tiposAcao: [],
      tipoAcao: null,
      objetosAcao: [],
      objetoAcao: null,
      dataDistribuicaoInicial: '',
      dataDistribuicaoFinal: '',
      dataArquivamentoInicial: '',
      dataArquivamentoFinal: '',
      importanteEmpresa: null,
      importanteParaMim: null,
      estrategico: null,
      openSpinner: false,
      relatorioArquivo: false,
      processoJudicial: '',
      processoAdmnistrativo: '',
      //Alteração em lote
      ritos: [],
      processos: [],
      selectProcessos: null,
      modalAlterarProcessosLote: false,
      responsavelAlerarLote: null,
      bancadaAlterarLote: null,
      statusProcessualAlterarLote: null,
      ufAlterarLote: null,
      ritoAlterarLote: null,
      quantidadeProcessosAftados: '0',
      contingenciaContabilAlterarLote: null,
      contingenciaVazia: null,
      ritoVazio: null,
      processosReservados: [],
      modalProcessosReservados: false,
      selectProcessosReservados: null,
    };

    this.relatorioProcessoService = new RelatorioProcessoService();
    this.pessoaService = new PessoaService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.statusProcessualService = new StatusProcessualService();
    this.tipoAcaoService = new TipoAcaoService();
    this.areaAtuacaoService = new AreaAtuacaoService();
    this.usuarioService = new UsuarioService();
    this.objetoAcaoService = new ObjetoAcaoService();
    this.ritoService = new RitoService();

    this.consultarPessoa = this.consultarPessoa.bind(this);
    this.renderFooterAlterarProcessosLote = this.renderFooterAlterarProcessosLote.bind(this);
    this.renderFooterProcessosReservados = this.renderFooterProcessosReservados.bind(this);
    this.excluirProcessosReservados = this.excluirProcessosReservados.bind(this);

    this.importanteEmpresa = [
      {codigo: 'S', nome: 'Sim'},
      {codigo: 'N', nome: 'Não'}
    ];

    this.importanteParaMim = [
      {codigo: 'S', nome: 'Sim'},
      {codigo: 'N', nome: 'Não'}
    ];

    this.estrategico = [
      {codigo: 'S', nome: 'Sim'},
      {codigo: 'N', nome: 'Não'}
    ];

    this.simNaoGenerico = [
      {codigo: 'S', nome: 'Sim'},
      {codigo: 'N', nome: 'Não'}
    ]

    this.contingenciaContabil = [
      {codigo: 'PR', nome: 'Provável'},
      {codigo: 'PO', nome: 'Possível'},
      {codigo: 'RE', nome: 'Remoto'}
    ]

    this.estados = [
      {codigo: 'AC', nome: 'Acre'},
      {codigo: 'AL', nome: 'Alagoas'},
      {codigo: 'AM', nome: 'Amazonas'},
      {codigo: 'AP', nome: 'Amapá'},
      {codigo: 'BA', nome: 'Bahia'},
      {codigo: 'CE', nome: 'Ceará'},
      {codigo: 'DF', nome: 'Distrito Federal'},
      {codigo: 'ES', nome: 'Espírito Santo'},
      {codigo: 'GO', nome: 'Goiás'},
      {codigo: 'MA', nome: 'Maranhão'},
      {codigo: 'MG', nome: 'Minas Gerais'},
      {codigo: 'MS', nome: 'Mato Grosso do Sul'},
      {codigo: 'MT', nome: 'Mato Grosso'},
      {codigo: 'PA', nome: 'Pará'},
      {codigo: 'PB', nome: 'Paraíba'},
      {codigo: 'PE', nome: 'Pernambuco'},
      {codigo: 'PI', nome: 'Piauí'},
      {codigo: 'PR', nome: 'Paraná'},
      {codigo: 'RJ', nome: 'Rio de janeiro'},
      {codigo: 'RN', nome: 'Rio Grande do Norte'},
      {codigo: 'RO', nome: 'Rondônia'},
      {codigo: 'RR', nome: 'Roraima'},
      {codigo: 'RS', nome: 'Rio Grande do Sul'},
      {codigo: 'SC', nome: 'Santa Catarina'},
      {codigo: 'SE', nome: 'Sergipe'},
      {codigo: 'SP', nome: 'São Paulo'},
      {codigo: 'TO', nome: 'Tocantins'}
    ];

  }

  listarRitos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.ritoService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({ritos: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatórios de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  //Listas
  //Pessoas
  listarPessoas = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.pessoaService.listarPessoas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({pessoas: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatórios de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }
  //Filtragem de Pessoas
  consultarPessoa(event) {
    setTimeout(() => {
        let filterPessoas;
        if (!event.query.trim().length) {
            filterPessoas = [...this.state.pessoas];
        }
        else {
            filterPessoas = this.state.pessoas.filter((pessoa) => {
                return pessoa.nome.toLowerCase().startsWith(event.query.toLowerCase());
            });
        }

        this.setState({ filterPessoas });
    }, 250);
  }

  //Grupos de Trabalho
  listarGruposTrabalho = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.grupoTrabalhoService.listarGruposUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  //Status Processuais
  listarStatusProcessual = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.statusProcessualService.listarStatusProcessual(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({statusProcessuais: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  //Tipos de Ação
  listarTiposAcao = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.tipoAcaoService.listarTipoAcao(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposAcao: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  //Áreas de Atuação
  listaAreaAtuacao = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.areaAtuacaoService.listarAreaAtuacao(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({areasAtuacao: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  //Bancadas
  listarBancadas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.pessoaService.listarBancadas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({bancadas: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatórios de Processos', detail:'Erro ao listar bancadas', life: 4000});
      });
  }

  //Responsáveis
  listarResponsaveis = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.usuarioService.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatórios de Processos', detail:'Erro ao listar Usuarios', life: 4000});
      })
  }

  listarObjetosAcao = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.objetoAcaoService.consultaRelatorio(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({objetosAcao: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  exportarRelatorio = async () => {
    if(this.state.pessoa == null && 
      this.state.grupoTrabalho == null &&
      this.state.statusProcessual == null &&
      this.state.tipoAcao == null &&
      this.state.areaAtuacao == null &&
      (this.state.dataDistribuicaoInicial == null || this.state.dataDistribuicaoInicial == '') &&
      (this.state.dataDistribuicaoFinal == null || this.state.dataDistribuicaoFinal == '') &&
      (this.state.dataCadastroInicial == null || this.state.dataCadastroInicial == '') &&
      (this.state.dataCadastroFinal == null || this.state.dataCadastroFinal == '') &&
      this.state.estado == null &&
      (this.state.dataArquivamentoInicial == null || this.state.dataArquivamentoInicial == '') &&
      (this.state.dataArquivamentoFinal == null || this.state.dataArquivamentoFinal == '') &&
      this.state.importanteEmpresa == null &&
      this.state.importanteParaMim == null &&
      this.state.estrategico == null &&
      this.state.responsavel == null &&
      this.state.objetoAcao == null &&
      this.state.contingenciaVazia == null &&
      this.state.processoJudicial == '' &&
      this.state.processoAdmnistrativo == '' &&
      this.state.ritoVazio == null &&
      this.state.bancada == null) {
       this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:'Nenhum filtro selecionado', life: 4000});
       return;
    }
    //return;
    const usuarioLogado = this.context.usuarioAutenticado;
    var areaAtuacao = 0;
    var statusProcessual = 0;
    var uf = '0';
    var importanteEmpresa = '0';
    var importanteParaMim = '0';
    var estrategico = '0';
    var responsavel = '0';
    var banca = '0';
    var objetoAcao = '0';
    var contingenciaVazia = 'N';
    var ritoVazio = 'N';
    var processoJudicial = '0';
    var processoAdministrativo = '0';


    if(this.state.areaAtuacao != null) {
      areaAtuacao = this.state.areaAtuacao.codigo;
    }

    if(this.state.statusProcessual != null) {
      statusProcessual = this.state.statusProcessual.codigo;
    }

    if(this.state.estado != null) {
      uf = this.state.estado.codigo;
    }

    if(this.state.importanteEmpresa != null) {
      importanteEmpresa = this.state.importanteEmpresa.codigo;
    }

    if(this.state.importanteParaMim != null) {
      importanteParaMim = this.state.importanteParaMim.codigo;
    }

    if(this.state.estrategico != null) {
      estrategico = this.state.estrategico.codigo;
    }

    if(this.state.responsavel != null) {
      responsavel = this.state.responsavel.codigo;
    }

    if(this.state.bancada != null) {
      banca = this.state.bancada.codigo;
    }

    if(this.state.contingenciaVazia != null) {
      contingenciaVazia = this.state.contingenciaVazia.codigo;
    }

    if(this.state.ritoVazio != null) {
      ritoVazio = this.state.ritoVazio.codigo;
    }

    if(this.state.processoJudicial != '') {
      processoJudicial = this.state.processoJudicial;
    }

    if(this.state.processoAdmnistrativo != '') {
      processoAdministrativo = '0';
    }

    var contador = 0;
    var tamanhoLista = 0;

    //Pessoas
    var codigosPessoa = '0';
    if(this.state.pessoa != null) {
      contador = 0;
      tamanhoLista = this.state.pessoa.length;
      for(let i = 0; i < this.state.pessoa.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosPessoa = codigosPessoa + this.state.pessoa[i].codigo + ",";
        } else {
          codigosPessoa = codigosPessoa + this.state.pessoa[i].codigo;
        }
        contador++;
      }
    }

    //Grupos de Trabalho
    var codigosGrupos = '0';
    if(this.state.grupoTrabalho != null) {
      contador = 0;
      tamanhoLista = this.state.grupoTrabalho.length;
      for(let i = 0; i < this.state.grupoTrabalho.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosGrupos = codigosGrupos + this.state.grupoTrabalho[i].codigo + ",";
        } else {
          codigosGrupos = codigosGrupos + this.state.grupoTrabalho[i].codigo;
        }

        contador++;
      }
    }

    //Objetos de Ação
    var codigosObjetos = '0';
    if(this.state.objetoAcao != null) {
      contador = 0;
      tamanhoLista = this.state.objetoAcao.length;
      for(let i = 0; i < this.state.objetoAcao.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosObjetos = codigosObjetos + this.state.objetoAcao[i].codigo + ",";
        } else {
          codigosObjetos = codigosObjetos + this.state.objetoAcao[i].codigo;
        }

        contador++;
      }
    }

    //Data da distribuição
    var dataDistribuicaoInicial = '0';
    var dataDistribuicaoFinal = '0';
    if(this.state.dataDistribuicaoInicial != null && this.state.dataDistribuicaoInicial != '' && 
       this.state.dataDistribuicaoFinal != null && this.state.dataDistribuicaoFinal != '') {
      //Data inicial
      var dateInicial = this.state.dataDistribuicaoInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataDistribuicaoInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataDistribuicaoFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataDistribuicaoFinal =  year+"-"+month+"-"+day;
    }

    //Data de Cadastro
    var dataCadastroInicial = '0';
    var dataCadastroFinal = '0';
    if(this.state.dataCadastroInicial != null && this.state.dataCadastroInicial != '' && 
       this.state.dataCadastroFinal != null && this.state.dataCadastroFinal != '') {
      //Data inicial
      var dateInicial = this.state.dataCadastroInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataCadastroInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataCadastroFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataCadastroFinal =  year+"-"+month+"-"+day;
    }

    //Data de Arquivamento
    var dataArquivamentoInicial = '0';
    var dataArquivamentoFinal = '0';
    if(this.state.dataArquivamentoInicial != null && this.state.dataArquivamentoInicial != '' && 
       this.state.dataArquivamentoFinal != null && this.state.dataArquivamentoFinal != '') {
      //Data inicial
      var dateInicial = this.state.dataArquivamentoInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataArquivamentoInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataArquivamentoFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataArquivamentoFinal =  year+"-"+month+"-"+day;
    }

    const filtro = {
      pessoa: codigosPessoa,
      grupoTrabalho: codigosGrupos,
      areaAtucacao: areaAtuacao,
      dataInicialDistribuicao: dataDistribuicaoInicial,
      dataFinalDistribuicao: dataDistribuicaoFinal,
      statusProcessual: statusProcessual,
      excetoProcessosArquivados: '',
      dataInicialCadastro: dataCadastroInicial,
      dataFinalCadastro: dataCadastroFinal,
      importanteEmpresa: importanteEmpresa,
      importanteParaMim: importanteParaMim,
      estrategico: estrategico,
      responsavel: responsavel,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo,
      uf: uf,
      objetoAcao: codigosObjetos,
      dataArquivamentoInicial: dataArquivamentoInicial,
      dataArquivamentoFinal: dataArquivamentoFinal,
      banca: banca,
      contingenciaVazia: contingenciaVazia,
      ritoVazio: ritoVazio,
      numeroCnj: processoJudicial,
      numeroProcesso: processoAdministrativo,
      tipoRelatorio: 'R'
    };

    const relatorioProcesso = {
      usuario: usuarioLogado,
      campos: null,
      filtro: filtro
    };

    this.setState({openSpinner: true});
    await this.relatorioProcessoService.exportarRelatorioFama(relatorioProcesso)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Relatório de Processo', detail:'Processo gerado com sucesso', life: 4000});
        this.download(response.data);
        //this.consultaRelatoriosUsuario();
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processo', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  consultarProcesssos = async () => {
    if(this.state.pessoa == null && 
      this.state.grupoTrabalho == null &&
      this.state.statusProcessual == null &&
      this.state.tipoAcao == null &&
      this.state.areaAtuacao == null &&
      (this.state.dataDistribuicaoInicial == null || this.state.dataDistribuicaoInicial == '') &&
      (this.state.dataDistribuicaoFinal == null || this.state.dataDistribuicaoFinal == '') &&
      (this.state.dataCadastroInicial == null || this.state.dataCadastroInicial == '') &&
      (this.state.dataCadastroFinal == null || this.state.dataCadastroFinal == '') &&
      this.state.estado == null &&
      (this.state.dataArquivamentoInicial == null || this.state.dataArquivamentoInicial == '') &&
      (this.state.dataArquivamentoFinal == null || this.state.dataArquivamentoFinal == '') &&
      this.state.importanteEmpresa == null &&
      this.state.importanteParaMim == null &&
      this.state.estrategico == null &&
      this.state.responsavel == null &&
      this.state.objetoAcao == null &&
      this.state.contingenciaVazia == null &&
      this.state.ritoVazio == null &&
      this.state.processoJudicial == '' &&
      this.state.processoAdmnistrativo == '' &&
      this.state.bancada == null) {
       this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:'Nenhum filtro selecionado', life: 4000});
       return;
    }
    //return;
    const usuarioLogado = this.context.usuarioAutenticado;
    var areaAtuacao = 0;
    var statusProcessual = 0;
    var uf = '0';
    var importanteEmpresa = '0';
    var importanteParaMim = '0';
    var estrategico = '0';
    var responsavel = '0';
    var banca = '0';
    var objetoAcao = '0';
    var ritoVazio = 'N';
    var contingenciaVazia = 'N';
    var processoJudicial = '0';
    var processoAdministrativo = '0';

    if(this.state.areaAtuacao != null) {
      areaAtuacao = this.state.areaAtuacao.codigo;
    }

    if(this.state.statusProcessual != null) {
      statusProcessual = this.state.statusProcessual.codigo;
    }

    if(this.state.estado != null) {
      uf = this.state.estado.codigo;
    }

    if(this.state.importanteEmpresa != null) {
      importanteEmpresa = this.state.importanteEmpresa.codigo;
    }

    if(this.state.importanteParaMim != null) {
      importanteParaMim = this.state.importanteParaMim.codigo;
    }

    if(this.state.estrategico != null) {
      estrategico = this.state.estrategico.codigo;
    }

    if(this.state.responsavel != null) {
      responsavel = this.state.responsavel.codigo;
    }

    if(this.state.bancada != null) {
      banca = this.state.bancada.codigo;
    }

    if(this.state.contingenciaVazia != null) {
      contingenciaVazia = this.state.contingenciaVazia.codigo;
    }

    if(this.state.ritoVazio != null) {
      ritoVazio = this.state.ritoVazio.codigo;
    }

    if(this.state.processoJudicial != '') {
      processoJudicial = this.state.processoJudicial;
    }

    if(this.state.processoAdmnistrativo != '') {
      processoAdministrativo = '0';
    }

    var contador = 0;
    var tamanhoLista = 0;

    //Pessoas
    var codigosPessoa = '0';
    if(this.state.pessoa != null) {
      contador = 0;
      tamanhoLista = this.state.pessoa.length;
      for(let i = 0; i < this.state.pessoa.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosPessoa = codigosPessoa + this.state.pessoa[i].codigo + ",";
        } else {
          codigosPessoa = codigosPessoa + this.state.pessoa[i].codigo;
        }
        contador++;
      }
    }

    //Grupos de Trabalho
    var codigosGrupos = '0';
    if(this.state.grupoTrabalho != null) {
      contador = 0;
      tamanhoLista = this.state.grupoTrabalho.length;
      for(let i = 0; i < this.state.grupoTrabalho.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosGrupos = codigosGrupos + this.state.grupoTrabalho[i].codigo + ",";
        } else {
          codigosGrupos = codigosGrupos + this.state.grupoTrabalho[i].codigo;
        }

        contador++;
      }
    }

    //Objetos de Ação
    var codigosObjetos = '0';
    if(this.state.objetoAcao != null) {
      contador = 0;
      tamanhoLista = this.state.objetoAcao.length;
      for(let i = 0; i < this.state.objetoAcao.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosObjetos = codigosObjetos + this.state.objetoAcao[i].codigo + ",";
        } else {
          codigosObjetos = codigosObjetos + this.state.objetoAcao[i].codigo;
        }

        contador++;
      }
    }

    //Data da distribuição
    var dataDistribuicaoInicial = '0';
    var dataDistribuicaoFinal = '0';
    if(this.state.dataDistribuicaoInicial != null && this.state.dataDistribuicaoInicial != '' && 
       this.state.dataDistribuicaoFinal != null && this.state.dataDistribuicaoFinal != '') {
      //Data inicial
      var dateInicial = this.state.dataDistribuicaoInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataDistribuicaoInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataDistribuicaoFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataDistribuicaoFinal =  year+"-"+month+"-"+day;
    }

    //Data de Cadastro
    var dataCadastroInicial = '0';
    var dataCadastroFinal = '0';
    if(this.state.dataCadastroInicial != null && this.state.dataCadastroInicial != '' && 
       this.state.dataCadastroFinal != null && this.state.dataCadastroFinal != '') {
      //Data inicial
      var dateInicial = this.state.dataCadastroInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataCadastroInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataCadastroFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataCadastroFinal =  year+"-"+month+"-"+day;
    }

    //Data de Arquivamento
    var dataArquivamentoInicial = '0';
    var dataArquivamentoFinal = '0';
    if(this.state.dataArquivamentoInicial != null && this.state.dataArquivamentoInicial != '' && 
       this.state.dataArquivamentoFinal != null && this.state.dataArquivamentoFinal != '') {
      //Data inicial
      var dateInicial = this.state.dataArquivamentoInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataArquivamentoInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataArquivamentoFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataArquivamentoFinal =  year+"-"+month+"-"+day;
    }

    const filtro = {
      pessoa: codigosPessoa,
      grupoTrabalho: codigosGrupos,
      areaAtucacao: areaAtuacao,
      dataInicialDistribuicao: dataDistribuicaoInicial,
      dataFinalDistribuicao: dataDistribuicaoFinal,
      statusProcessual: statusProcessual,
      excetoProcessosArquivados: '',
      dataInicialCadastro: dataCadastroInicial,
      dataFinalCadastro: dataCadastroFinal,
      importanteEmpresa: importanteEmpresa,
      importanteParaMim: importanteParaMim,
      estrategico: estrategico,
      responsavel: responsavel,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo,
      uf: uf,
      objetoAcao: codigosObjetos,
      dataArquivamentoInicial: dataArquivamentoInicial,
      dataArquivamentoFinal: dataArquivamentoFinal,
      banca: banca,
      contingenciaVazia: contingenciaVazia,
      ritoVazio: ritoVazio,
      numeroCnj: processoJudicial,
      numeroProcesso: processoAdministrativo,
      tipoRelatorio: 'L'
    };

    const relatorioProcesso = {
      usuario: usuarioLogado,
      campos: null,
      filtro: filtro
    };

    this.setState({openSpinner: true});
    await this.relatorioProcessoService.consultarProcessos(relatorioProcesso)
      .then(response => {
        this.setState({processos: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processo', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  consultarRelatorio = (relatorio) => {
    this.relatorioProcessoService.consultarRelatorio(relatorio.codigo)
      .then(response => {
        this.setState({relatorioArquivo: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Processo', detail:'Erro ao consultar relatório', life: 4000});
      })
  }

  async download(relatorio){
    await this.consultarRelatorio(relatorio);
    await this.relatorioProcessoService.download(relatorio.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.relatorioArquivo.relatorio); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Processo', detail:'Erro executar download de relatório', life: 4000});
      })
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarPessoas();
    await this.listarGruposTrabalho();
    await this.listarStatusProcessual();
    await this.listarTiposAcao();
    await this.listaAreaAtuacao();
    await this.listarBancadas();
    await this.listarResponsaveis();
    await this.listarObjetosAcao();
    await this.listarRitos();
    this.setState({openSpinner: false});
  }

  limparCampos = () => {
    this.setState({pessoa: null});
    this.setState({statusProcessual: null});
    this.setState({grupoTrabalho: null});
    this.setState({statusProcessual: null});
    this.setState({tipoAcao: null});
    this.setState({areaAtuacao: null});
    this.setState({responsavel: null});
    this.setState({bancada: null});
    this.setState({importanteEmpresa: null});
    this.setState({importanteParaMim: null});
    this.setState({estrategico: null});
    this.setState({estado: null});
    this.setState({objetoAcao: null});
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  alterarEmLote = async () => {
    let processos = [];
    for(let i = 0; i < this.state.selectProcessosReservados.length; i++) {
      const processo = {
        codigo: this.state.selectProcessosReservados[i].codigo
      }

      processos.push(processo);

    }

    var contingencia = '0';
    var uf = '0';

    if(this.state.contingenciaContabilAlterarLote != null) {
      contingencia = this.state.contingenciaContabilAlterarLote.codigo;
    }

    if(this.state.ufAlterarLote != null) {
      uf = this.state.ufAlterarLote.codigo;
    }

    const alterar = {
      processos: processos,
      responsavel: this.state.responsavelAlerarLote,
      banca: this.state.bancadaAlterarLote,
      statusProcessual: this.state.statusProcessualAlterarLote,
      rito: this.state.ritoAlterarLote,
      contingencia: contingencia,
      uf: uf
    }

    this.setState({openSpinner:true});
    await this.relatorioProcessoService.alterarProccessosLote(alterar)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Alteração em Lote', detail:`Quantidade de procesos alterados: ${response.data}`, life: 4000});
        this.consultarProcesssos();
        this.consultarProcessosReservados();
        this.fecharModal('modalAlterarProcessosLote');
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Alteração em Lote', detail:`${this.state.detail}`, life: 4000});
        this.setState({openSpinner:false});
      })
      this.setState({openSpinner:false});
  }

  renderFooterAlterarProcessosLote(name) {
    return (
        <div className="left">
            <Button label="Alterar"
                    className="p-button-primary p-button-text"
                    onClick={this.alterarEmLote}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterProcessosReservados(name) {
    return (
        <div className="left">
            <Button label="Alterar em Lote"
                    className="p-button-primary p-button-text"
                    onClick={this.processosAlterarLote}/>
            &nbsp;
            <Button label="Excluir Processos" 
                    className="p-button-danger p-button-text"
                    onClick={() => this.confirmaExclusaoReservados()}/>
            &nbsp;
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  processosAlterarLote = () => {
    if(this.state.selectProcessosReservados == null || this.state.selectProcessosReservados.length == 0) {
      this.toast.show({severity:'error', summary: 'Alteração em Lote', detail:'Nenhum proccesso foi selecionado', life: 4000});
      return;
    }
    this.setState({responsavelAlerarLote: null});
    this.setState({contingenciaContabilAlterarLote: null});
    this.setState({ritoAlterarLote: null});
    this.setState({ufAlterarLote: null});
    this.setState({statusProcessualAlterarLote: null});
    this.setState({bancadaAlterarLote: null});
    this.setState({quantidadeProcessosAftados: this.state.selectProcessosReservados.length});
    this.abrirModal('modalAlterarProcessosLote');
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  incluirProcessoLote = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.selectProcessos == null || this.state.selectProcessos.length == 0) {
      this.toast.show({severity:'error', summary: 'Alteração em Lote', detail:'Nenhum proccesso foi selecionado', life: 4000});
      return;
    }

    var processos = [];
    for(let i = 0; i < this.state.selectProcessos.length; i++) {
      processos.push(this.state.selectProcessos[i].codigo);
    }

    const processoIncluir = {
      usuario: usuarioLogado.codigo,
      processos: processos
    };

    this.setState({openSpinner: true});
    await this.relatorioProcessoService.incluirProcessoLote(processoIncluir)
      .then(response => {
        this.consultarProcesssos();
        this.toast.show({severity:'success', summary: 'Alteração em Lote', detail:'Processo(s) incluído(s)', life: 4000});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Alteração em Lote', detail:`${this.state.detail}`, life: 4000});
        this.setState({openSpinner:false});
      });
      this.setState({openSpinner: false});
  }

  consultarProcessosReservados = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({selectProcessosReservados: null});
    this.setState({openSpinner:true});
    await this.relatorioProcessoService.consultarProcessosReservados(usuarioLogado.codigo)
      .then(response => {
        this.setState({processosReservados: response.data});
        this.abrirModal('modalProcessosReservados');
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Alteração em Lote', detail:`${this.state.detail}`, life: 4000});
        this.setState({openSpinner:false});
      });
      this.setState({openSpinner:false});
  }

  confirmaExclusaoReservados() {
    if(this.state.selectProcessosReservados == null || this.state.selectProcessosReservados.length == 0) {
      this.toast.show({severity:'error', summary: 'Alteração em Lote', detail:'Nenhum processo foi selecionado para excluir', life: 4000});
      return;
    }
    confirmDialog({
        message: 'Deseja realmente excluir os processos reservados?',
        header: 'Exclusão de Processos Reservados',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.excluirProcessosReservados,
        reject: this.reject
    });
  }

  async excluirProcessosReservados() {
    const usuarioLogado = this.context.usuarioAutenticado;
    var processos = [];
    for(let i = 0; i < this.state.selectProcessosReservados.length; i++) {
      processos.push(this.state.selectProcessosReservados[i].codigo);
    }
    const dados = {
      usuario: usuarioLogado.codigo,
      processos: processos
    }

    this.setState({openSpinner:true});
    await this.relatorioProcessoService.excluirProcessoReservados(dados)
      .then(response => {
        this.consultarProcessosReservados();
        this.toast.show({severity:'success', summary: 'Alteração em Lote', detail:'Processo(s) excluído(s)', life: 4000});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Alteração em Lote', detail:`${this.state.detail}`, life: 4000});
        this.setState({openSpinner:false});
      });

      this.setState({openSpinner:false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={this.state.openSpinner}>
            <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
          </Backdrop>
          <div className="content-wrapper">
            <section className="content-header">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-primary card-outline">
                      <div className="card-header">
                        <h3 className="card-title">
                          <i className="pi pi-file-pdf"></i>
                          <span> Relatório de Processos</span>
                        </h3>  
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>Pessoa(s) (Autores, Parte Contrária, Advogados outra parte)</label>
                              <AutoComplete value={this.state.pessoa}
                                            suggestions={this.state.filterPessoas} 
                                            completeMethod={this.consultarPessoa}
                                            style={{width: '100%'}} 
                                            field="nome" multiple onChange={(e) => this.setState({pessoa: e.value })} 
                                            className="p-autoComplete-sm p-d-block p-mb-0"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Processo Judicial</label>
                              <InputText id="processoJudicial" 
                                         type="text" 
                                         style={{width: '100%'}} 
                                         value={this.state.processoJudicial}
                                         onChange={e => this.setState({processoJudicial: e.target.value})}
                                         className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Processo Administrativo</label>
                              <InputText id="processoAdministrativo" 
                                         type="text" 
                                         style={{width: '100%'}} 
                                         value={this.state.processoAdmnistrativo}
                                         onChange={e => this.setState({processoAdmnistrativo: e.target.value})}
                                         className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Grupo de Trbalho</label>
                              <MultiSelect inputId="multiselect" 
                                          value={this.state.grupoTrabalho} 
                                          options={this.state.gruposTrabalho} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ grupoTrabalho: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Status Processual</label>
                              <Dropdown   inputId="statusProcessualId" 
                                          value={this.state.statusProcessual} 
                                          options={this.state.statusProcessuais} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ statusProcessual: e.value })} 
                                          filter showClear filterBy="descricao"
                                          optionLabel="descricao" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Tipo de Ação</label>
                              <Dropdown   inputId="tipoAcaoId" 
                                          value={this.state.tipoAcao} 
                                          options={this.state.tiposAcao} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ tipoAcao: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Área de Atuação</label>
                              <Dropdown   inputId="areaAtuacaoId" 
                                          value={this.state.areaAtuacao} 
                                          options={this.state.areasAtuacao} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ areaAtuacao: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-8">
                            <div className="form-group">
                              <label>Objetos de Ação</label>
                              <MultiSelect inputId="multiselect" 
                                          value={this.state.objetoAcao} 
                                          options={this.state.objetosAcao} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ objetoAcao: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Data de Cadastro</label>
                              <Calendar id="mask" 
                                        value={this.state.dataCadastroInicial} 
                                        onChange={(e) => this.setState({ dataCadastroInicial: e.value })} 
                                        style={{width: '100%', height: '32px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              &nbsp;
                              <Calendar id="mask" 
                                          value={this.state.dataCadastroFinal} 
                                          onChange={(e) => this.setState({ dataCadastroFinal: e.value })} 
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Data de Distribuição</label>
                              <Calendar id="mask" 
                                        value={this.state.dataDistribuicaoInicial} 
                                        onChange={(e) => this.setState({ dataDistribuicaoInicial: e.value })} 
                                        style={{width: '100%', height: '32px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              &nbsp;
                              <Calendar id="mask" 
                                          value={this.state.dataDistribuicaoFinal} 
                                          onChange={(e) => this.setState({ dataDistribuicaoFinal: e.value })} 
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Data de Arquivamento</label>
                              <Calendar id="mask" 
                                        value={this.state.dataArquivamentoInicial} 
                                        onChange={(e) => this.setState({ dataArquivamentoInicial: e.value })} 
                                        style={{width: '100%', height: '32px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              &nbsp;
                              <Calendar id="mask" 
                                          value={this.state.dataArquivamentoFinal} 
                                          onChange={(e) => this.setState({ dataArquivamentoFinal: e.value })} 
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Responsável</label>
                              <Dropdown inputId="responsavel" 
                                          value={this.state.responsavel} 
                                          options={this.state.responsaveis} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ responsavel: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Bancada</label>
                              <Dropdown inputId="bancada" 
                                          value={this.state.bancada} 
                                          options={this.state.bancadas} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ bancada: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Importante Empresa</label>
                              <Dropdown   inputId="importanteEmpresa" 
                                          value={this.state.importanteEmpresa} 
                                          options={this.importanteEmpresa} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ importanteEmpresa: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Estratégico</label>
                              <Dropdown   inputId="estrategico" 
                                          value={this.state.estrategico} 
                                          options={this.estrategico} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ estrategico: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Importante para mim</label>
                              <Dropdown   inputId="importanteParaMim" 
                                          value={this.state.importanteParaMim} 
                                          options={this.importanteParaMim} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ importanteParaMim: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>UF</label>
                              <Dropdown inputId="uf" 
                                        value={this.state.estado} 
                                        options={this.estados} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ estado: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Contingência Vazia</label>
                              <Dropdown inputId="contingenciaVazia" 
                                          value={this.state.contingenciaVazia} 
                                          options={this.simNaoGenerico} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ contingenciaVazia: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Rito Vazio</label>
                              <Dropdown inputId="ritoVazio" 
                                          value={this.state.ritoVazio} 
                                          options={this.simNaoGenerico} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ ritoVazio: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <hr></hr>
                        <br></br>
                        <div style={{paddingLeft: '12px'}}>
                            <Button label="Consultar"
                                      className="p-button-primary p-button-text"
                                      onClick={this.consultarProcesssos}/>
                            &nbsp;
                            <Button label="Reservar Processo"
                                      className="p-button-primary p-button-text"
                                      onClick={this.incluirProcessoLote}/>
                            &nbsp;
                            <Button label="Consultar Processos Reservados"
                                      className="p-button-primary p-button-text"
                                      onClick={this.consultarProcessosReservados}/>
                            &nbsp;
                            <Button label="Exportar Relatório"
                                      className="p-button-primary p-button-text"
                                      onClick={this.exportarRelatorio}/>
                            &nbsp;
                            <Button label="Limpar Campos" 
                                    className="p-button-secondary p-button-text"
                                    onClick={this.limparCampos}/>
                        
                        </div>
                        <br></br>
                        <br></br>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <DataTable  value={this.state.processos}  paginator responsiveLayout="scroll"
                                          selection={this.state.selectProcessos} onSelectionChange={(e) => this.setState({ selectProcessos: e.value })}
                                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                                          selectionMode="multiple">
                                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                                <Column field="codigo" header="Código"></Column>
                                <Column field="numeroCnj" header="Processo Judicial"></Column>
                                <Column field="numeroProcesso" header="Processo Administrativo"></Column>
                                <Column field="dataCadastro" header="Dt. cadastro"></Column>
                                <Column field="autores" header="Auttores"></Column>
                                <Column field="documentoAutor" header="Cpf/Cnpj Autor"></Column>
                                <Column field="reus" header="Réus"></Column>
                                <Column field="documentoReu" header="Cpf/Cnpj Réu"></Column>
                                <Column field="grupoTrabalho" header="Grupo de Trabalho"></Column>
                                <Column field="statusProcessual" header="Status Processual"></Column>
                                <Column field="uf" header="UF"></Column>
                                <Column field="responsavel" header="Responsável"></Column>
                                <Column field="banca" header="Banca"></Column>
                                <Column field="contigenciaContabil" header="Cont. Contábil"></Column>
                                <Column field="fase" header="Fase Procesual"></Column>
                                <Column field="rito" header="Rito"></Column>
                                <Column field="provavel" header="Vl. Provável"></Column>
                                <Column field="possivel" header="Vl. Possível"></Column>
                                <Column field="remoto" header="Vl. Remoto"></Column>
                                <Column field="valorCausa" header="Vl. Causa"></Column>
                              </DataTable>
                            </div>
                          </div>
                        </div>
                        <Dialog header="Alterar processos em lote" autoComplete="nope"
                                visible={this.state.modalAlterarProcessosLote} 
                                style={{ width: '43vw' }} 
                                footer={this.renderFooterAlterarProcessosLote('modalAlterarProcessosLote')} 
                                onHide={() => this.fecharModal('modalAlterarProcessosLote')}>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>Quantidade de processos que serão afetados:&nbsp;<strong>{this.state.quantidadeProcessosAftados}</strong></label>
                                </div>
                              </div>
                            </div>
                            <hr></hr>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>Responsável</label>
                                  <Dropdown inputId="responsavel" 
                                            value={this.state.responsavelAlerarLote} 
                                            options={this.state.responsaveis} 
                                            style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                            onChange={(e) => this.setState({ responsavelAlerarLote: e.value })} 
                                            filter showClear filterBy="nome"
                                            optionLabel="nome" />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>Rito de Processo</label>
                                  <Dropdown inputId="ritoProcesso" 
                                            value={this.state.ritoAlterarLote} 
                                            options={this.state.ritos} 
                                            style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                            onChange={(e) => this.setState({ ritoAlterarLote: e.value })} 
                                            filter showClear filterBy="nome"
                                            optionLabel="nome" />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>Status Processual</label>
                                  <Dropdown inputId="statusProcessualIdAlterarLote" 
                                            value={this.state.statusProcessualAlterarLote} 
                                            options={this.state.statusProcessuais} 
                                            style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                            onChange={(e) => this.setState({ statusProcessualAlterarLote: e.value })} 
                                            filter showClear filterBy="descricao"
                                            optionLabel="descricao" />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>UF</label>
                                  <Dropdown inputId="ufAlterarLote" 
                                            value={this.state.ufAlterarLote} 
                                            options={this.estados} 
                                            style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                            onChange={(e) => this.setState({ ufAlterarLote: e.value })} 
                                            filter showClear filterBy="nome"
                                            optionLabel="nome" />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>Bancada</label>
                                  <Dropdown inputId="bancadaAlterarLote" 
                                            value={this.state.bancadaAlterarLote} 
                                            options={this.state.bancadas} 
                                            style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                            onChange={(e) => this.setState({ bancadaAlterarLote: e.value })} 
                                            filter showClear filterBy="nome"
                                            optionLabel="nome" />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>Contigênca Contábil</label>
                                  <Dropdown inputId="contingenciaContabilAlterarLote" 
                                            value={this.state.contingenciaContabilAlterarLote} 
                                            options={this.contingenciaContabil} 
                                            style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                            onChange={(e) => this.setState({ contingenciaContabilAlterarLote: e.value })} 
                                            filter showClear filterBy="nome"
                                            optionLabel="nome" />
                                </div>
                              </div>
                            </div>
                        </Dialog>
                        <Dialog header="Processos Reservados" autoComplete="nope"
                                visible={this.state.modalProcessosReservados} 
                                footer={this.renderFooterProcessosReservados('modalProcessosReservados')} 
                                onHide={() => this.fecharModal('modalProcessosReservados')}>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <DataTable  value={this.state.processosReservados}  paginator responsiveLayout="scroll"
                                            selection={this.state.selectProcessosReservados} onSelectionChange={(e) => this.setState({ selectProcessosReservados: e.value })}
                                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                            currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                                            selectionMode="multiple">
                                    <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                                    <Column field="codigo" header="Código"></Column>
                                    <Column field="numeroCnj" header="Processo Judicial"></Column>
                                    <Column field="numeroProcesso" header="Processo Administrativo"></Column>
                                    <Column field="autor" header="Autor"></Column>
                                    <Column field="reu" header="Réu"></Column>
                                    <Column field="grupoTrabalho" header="Grupo de Trabalho"></Column>
                                    <Column field="statusProcessual" header="Status Processual"></Column>
                                  </DataTable>
                                </div>
                              </div>
                            </div>
                        </Dialog>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
      </>
    );
  }
}

RelatorioProcessoFama.contextType = AuthContext;
export default withRouter(RelatorioProcessoFama)
